var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-svg",style:({ width: `${_vm.boxWidth}px`, height: `${_vm.boxHeight}px` })},[_c('mark-loader',{attrs:{"size":_vm.markSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }